import { Component, OnInit, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Ticket, CartOffer } from '@app/modules/model/ticket';

import { languageSupport, languageService } from '@app/modules/common/language'
import { viewService } from '@app/modules/view';

@Component({
    selector: 'ui-cart-offer',
    templateUrl:'./ui-cart.html',
    styleUrls: [ 
        './ui-cart.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiCartOffer extends languageSupport implements OnInit, OnDestroy {
    @Input('ticket') _ticket: Ticket = null;
    @Input('offer') _offer: CartOffer = null;

    private _subscriptions = [];

    /***********************************/
    /* STARTS HERE                     */
    /***********************************/

    constructor(private lang: languageService, private change: ChangeDetectorRef, public view: viewService) {
        super(lang, change);
    }

    ngOnInit(){
        this._subscriptions.push(
            this.view.OnTheme.subscribe(
            data => {
                this.change.markForCheck();
            })
        );  

        this._subscriptions.push(
            this._offer.onRefresh.asObservable().subscribe(
            data => {
                this.change.markForCheck();
            })
        );    
    }

    ngOnDestroy(){
        super.OnDestroy();

        for(let _subscription of this._subscriptions){
            _subscription.unsubscribe();
        }
        this._subscriptions = [];
    }

    /***********************************/
    /* EVENT HANDLERS                  */
    /***********************************/

    @Output('onPanel') _onPanel = new EventEmitter<any>();     
    OnShowOffer(){
        this._onPanel.emit({
            scnd: 'opts',
            args: {
                ticketoffer: this._offer.requested[0]
            }
        });
    }    
}
